export default [
    {
        fileName: "image1.png",
        pathName: "/offers",
        title: "Oferte dedicate",
        description: "image1Text",
    },
    {
        fileName: "image2.png",
        pathName:
            "/events",
        title: "Evenimente",
        description: "image1Text",
    },
    {
        fileName: "image3.png",
        pathName:
            "/trainings",
        title: "Training-uri",
        description: "image1Text",
    },
];
